import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-body';
@customElement(tagName)
export class TmBody extends TmBaseComponent {
    @property({ type: Boolean })
    public shadow = true;

    @property({ type: Boolean })
    public background = true;

    @property({ type: Boolean })
    public padding = true;

    @property({ attribute: false })
    public fullHeight = true;

    protected render() {
        return html`
            <slot
                class=${classMap({
                    'h-full': this.fullHeight,
                    block: true,
                    'p-3': this.padding,
                    shadow: this.shadow,
                    'bg-primary': this.background,
                })}
            ></slot>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    margin-bottom: auto;
                    background-color: var(--container-page);
                    color: var(--primary-text-color);
                    height: 100%;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmBody;
    }
}
